<div class="bg-white fixed-top border-bottom d-none d-mg-block d-lg-block d-xl-block">
  <div class="px-5">
    <header class="d-flex flex-wrap align-items-center justify-content-between py-3">
      <div class="col-md-2 mb-2 mb-md-0 d-flex logo">
        <a href="/" class="d-inline-flex link-body-emphasis text-decoration-none">
          <img class="w-auto" src="/assets/img/logo-black.svg" />
        </a>
      </div>

      <div class="col-md-10 d-flex align-items-center">
        <nav aria-label="breadcrumb" class="bg-white">
          <app-breadcrumb [breadcrumbs]="breadcrumbDataArray"></app-breadcrumb>
        </nav>

        <div class="d-flex align-items-center ml-auto">
          <button class="btn d-inline-flex align-items-center" [routerLink]="['/setting', 'notification-settings']">
            <div class="d-flex align-items-center">
              <img src="/assets/icons/setting-gear.svg" class="mr-2" />
            </div>
            Settings
          </button>
        </div>

        <div class="nav-item ml-2 account" ngbDropdown>
          <a class="nav-link nav-pill user-avatar pointer d-inline-flex align-items-center" ngbDropdownToggle>
            <div class="media align-items-center">
              <div class="media-body user-media-body">
                <div class="d-flex align-items-center">
                  <img src="/assets/icons/avatar.svg" class="mr-4" /> <!-- Added code -->
                  <div class="text-left">
                    <h5 class="mb-1 text-black">{{ currentUserEmail }}</h5>
                    <span>{{ currentAccountType }}</span>
                  </div>
                  <img src="assets/icons/arrow-down.svg" class="m-l-20" />
                </div>
              </div>
            </div>
          </a>

          <div class="dropdown-menu-right dropdown-menu-account" ngbDropdownMenu>
            <div class="log-arrow-up"></div>

            <span *ngIf="currentUserGroups.length > 0"
              class="dropdown-item pointer highlighted force-text-center pill-extra-bottom">
              <small>{{ getUserGroupsText() }}</small>
            </span>

            <a class="dropdown-item pointer" *ngIf="shouldShowRestoreAction()" (click)="goBackFromImpersonation()">
              Restore User
            </a>

            <a class="dropdown-item pointer" (click)="openSettings()">
              Settings
            </a>

            <a class="dropdown-item pointer" (click)="logout()">
              Logout
            </a>

            <div class="pt-3 text-center">
              Version {{ appVersion }}
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>

<nav class="top-toolbar navbar navbar-mobile navbar-tablet bg-white p-0 fixed-top">
  <ul class="navbar-nav nav-left">
    <li class="nav-item">
      <a href="javascript:void(0)" (click)="openSideBar()">
        <img src="assets/icons/menu-black.svg" class="h-25" />
      </a>
    </li>
  </ul>

  <ul class="navbar-nav nav-center site-logo">
    <li>
      <a routerLink="/dashboard">
        <div class="logo-custom">
          <img src="assets/img/logo-black.svg" alt="Logo" />
        </div>
      </a>
    </li>
  </ul>

  <ul class="navbar-nav nav-right">
    <li class="nav-item" ngbDropdown>
      <a ngbDropdownToggle>
        <img src="assets/icons/dots-black.svg" class="h-20" />
      </a>
      <div class="dropdown-menu-right dropdown-menu-account" ngbDropdownMenu>
        <div class="log-arrow-up"></div>
        <a class="dropdown-item pointer" (click)="openSettings()">Settings</a>
        <a class="dropdown-item pointer" (click)="logout()"> Logout</a>
      </div>
    </li>
  </ul>
</nav>

<nav aria-label="breadcrumb" class="bg-white fixed-top border-bottom d-block d-sm-block d-md-block d-lg-none z-2"
  style="margin-top: 75px">
  <app-breadcrumb [breadcrumbs]="breadcrumbDataArray"></app-breadcrumb>
</nav>